const getOuterHeight = (el: string | HTMLElement): number => {
  // Get the DOM Node if you pass in a string
  const element: HTMLElement | null = (typeof el === 'string') ? document.querySelector(el) : el;
  if (element) {
    const styles = window.getComputedStyle(element);
    const margin = parseFloat(styles['marginTop'] || '0') +
      parseFloat(styles['marginBottom'] || '0');
    return Math.ceil(element.offsetHeight + margin);
  }
  return 0;
};

const getPageHeight = () => {
  const bodyEle = document.body;
  const htmlEle = document.documentElement;
  return htmlEle ? Math.max(bodyEle.scrollHeight, bodyEle.offsetHeight,
    htmlEle.clientHeight, htmlEle.scrollHeight, htmlEle.offsetHeight) : 0;
};

const getPosition = (el: HTMLElement) => {
  let xPos = 0;
  let yPos = 0;

  while (el && document.documentElement) {
    if (el.tagName === 'BODY') {
      // deal with browser quirks with body/window/document and page scroll
      const xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      const yScroll = el.scrollTop || document.documentElement.scrollTop;

      xPos += (el.offsetLeft - xScroll + el.clientLeft);
      yPos += (el.offsetTop - yScroll + el.clientTop);
    } else {
      // for all other non-BODY elements
      xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
      yPos += (el.offsetTop - el.scrollTop + el.clientTop);
    }

    el = el.offsetParent as HTMLElement;
  }
  return {
    x: xPos,
    y: yPos,
  };
};

/**
 * returns the closest ancestor of the current element (or the current element itself)
 * which matches the selectors given in parameter.
 * If there isn't such an ancestor, it returns null.
 * Polyfill of Element.closest()
 * @param el HTMLElement
 * @param s string
 */
const closest = (el: HTMLElement, s: string) => {
  if (!Element.prototype.matches) {
    // @ts-ignore
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }
  let element: any = el;
  if (!document.documentElement || !document.documentElement.contains(element)) {
    return null;
  }
  do {
    if (element.matches(s)) {
      return element;
    }
    element = element.parentElement || element.parentNode;
  } while (element !== null && element.nodeType === 1);
  return null;
};

const getStyle = (el: any, styleProp: string) => {
  let value = (el.ownerDocument || document).defaultView;
  const defaultView = (el.ownerDocument || document).defaultView;
  // W3C standard way:
  if (defaultView && defaultView.getComputedStyle) {
    // sanitize property name to css notation
    // (hypen separated words eg. font-Size)
    styleProp = styleProp.replace(/([A-Z])/g, '-$1').toLowerCase();
    return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
  } else if (el.currentStyle) { // IE
    // sanitize property name to camelCase
    styleProp = styleProp.replace(/\-(\w)/g, (str, letter) => {
      return letter.toUpperCase();
    });
    value = el.currentStyle[styleProp];
    // convert other units to pixels on IE
    if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
      return ((val) => {
        const oldLeft = el.style.left;
        const oldRsLeft = el.runtimeStyle.left;
        el.runtimeStyle.left = el.currentStyle.left;
        el.style.left = val || 0;
        val = el.style.pixelLeft + 'px';
        el.style.left = oldLeft;
        el.runtimeStyle.left = oldRsLeft;
        return val;
      })(value);
    }
    return value;
  }
};

export default {
  getOuterHeight,
  getPageHeight,
  getPosition,
  closest,
  getStyle,
};
